module.exports = __webpack_public_path__ + "static/media/suit-spade.54aef2f2.png";